module.exports = __webpack_public_path__ + "img/1790398183656_36700.7d1078ba.png";